// Environment types
export type Environment = 'DEV' | 'STAGE' | 'PROD'

// Environment configuration interface
interface EnvironmentConfig {
  environment: Environment;
  mainUrl: string;
  aiUrl: string;
  debug: boolean;
}

// Get the current environment
const getCurrentEnvironment = (): Environment => {
  const env = process.env.ENVIRONMENT || 'DEV'
  return env as Environment
}

// Get URL based on environment
const getMainUrl = (env: Environment): string => {
  const urls = {
    DEV: process.env.MAIN_URL_DEV,
    STAGE: process.env.MAIN_URL_STAGE,
    PROD: process.env.MAIN_URL_PROD,
  }
  const url = urls[env] || 'http://localhost:3000'
  return url
}

const getAiUrl = (env: Environment): string => {
  const urls = {
    DEV: process.env.AI_URL_DEV,
    STAGE: process.env.AI_URL_STAGE,
    PROD: process.env.AI_URL_PROD,
  }
  const url = urls[env] || 'http://localhost:3001'
  return url
}

// Get debug setting based on environment
const getDebugSetting = (env: Environment): boolean => {
  switch (env) {
    case 'DEV':
      return process.env.DEBUG_DEV === 'true'
    case 'STAGE':
      return process.env.DEBUG_STAGE === 'true'
    case 'PROD':
      return process.env.DEBUG_PROD === 'false'
    default:
      return false
  }
}

// Create the environment configuration
const currentEnv = getCurrentEnvironment()

export const config: EnvironmentConfig = {
  environment: currentEnv,
  mainUrl: getMainUrl(currentEnv),
  aiUrl: getAiUrl(currentEnv),
  debug: getDebugSetting(currentEnv),
}

// Helper functions
export const isDev = () => config.environment === 'DEV'
export const isStage = () => config.environment === 'STAGE'
export const isProd = () => config.environment === 'PROD'
export const isDebugEnabled = () => config.debug
